import { ListItem as MuiListItem, ListItemText, makeStyles } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles(() => ({
  lisItem: {
    width: '100%'
  }
}));

export default function ListItem(props) {
  const { text, handleClick } = props;
  const classes = useStyles();

  return (
    <MuiListItem button component='li' onClick={handleClick} className={classes.lisItem}>
      <ListItemText>{text}</ListItemText>
      <NavigateNextIcon />
    </MuiListItem>
  );
}
